import { render, staticRenderFns } from "./NewMiniCart.vue?vue&type=template&id=4cadef7c&"
import script from "./NewMiniCart.vue?vue&type=script&lang=js&"
export * from "./NewMiniCart.vue?vue&type=script&lang=js&"
import style0 from "./NewMiniCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports